export const REST_PUBLIC_URI =
  process.env.REACT_APP_BACKEND_API || "https://dev-api.finjam.ai";
